import api from "PFCore/api";
import { Id } from "PFTypes";
import { AccessRequest, AccessRequestStatus } from "PFTypes/access_request";

export type EditAccessRequestData = {
  id: Id;
  status: AccessRequestStatus;
};

export const editAccessRequest = ({ id, status }: EditAccessRequestData): Promise<AccessRequest> =>
  api({
    url: `admin/access_requests/${id}`,
    method: "PUT",
    data: { status },
    headers: {
      apiVersion: 1
    }
  });
